import React, { FC } from 'react';
import { AnyType } from '@src/models/common';
import { IDefaultComponentProps } from '@src/models/props';
import { JSONTree } from 'react-json-tree';
import { jsonViewerTheme } from './consts';

interface IJsonViewProps extends IDefaultComponentProps {
  data: AnyType;
}

export const JsonView: FC<IJsonViewProps> = ({ data }) => {
  return (
    <div>
      <JSONTree data={data} theme={jsonViewerTheme} hideRoot={true} />
    </div>
  );
};
